<div id="wrapper-canvas">
  <canvas id="canvas"></canvas>
  <canvas
    id="canvas-temp"
    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()"
    (mousedown)="onMouseDown($event)"
    (mousemove)="onMouseMove($event)"
    (mouseup)="onTouchEnd()"
    (mouseleave)="onTouchEnd()"
  ></canvas>

  @if (isDrawing && mode() === 'eraser') {
    <div
      class="cursor"
      [style.width.px]="thickness()"
      [style.height.px]="thickness()"
      [style.left.px]="position.x - thickness() / 2"
      [style.top.px]="position.y - thickness() / 2"
      (touchend)="onTouchEnd()"
    ></div>
  }
</div>
